import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

// @Redux

// @Models
import { CFFCaptureData } from '../../models/Models';
import { axiosEstimates } from '../../../../utils';
import Swal from 'sweetalert2';
import { useState } from 'react';
// @Utils

interface IParams {
  data?: CFFCaptureData;
}

export function useInvoiceFormCCF({ data }: IParams) {
  const { t } = useTranslation(['common']);
  const [dataInput, setDataInput] = useState<CFFCaptureData>({
    customerPayments: '',
    condition: '',
    deliveryby: {
      name: '',
      DUI: '',
    },
    receivedby: {
      name: '',
      DUI: '',
    },
  });

  const handleDataInput = (e: any) => {
    setDataInput(prev => ({
      ...prev,
      [e.name]: e.value,
    }));
  };
  const { control, getValues, setValue } = useForm<CFFCaptureData>({
    defaultValues: data,
  });
  const { id: budgetId, total } = useParams();

  const navigate = useNavigate();

  const activeSwalModal = (title: string, text: string, callback: () => {}) => {
    // eslint-disable-next-line no-lone-blocks
    {
      Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: t('general.cancel', { ns: 'common' }) || '',
        confirmButtonText: t('general.confirm', { ns: 'common' }) || '',
      }).then(result => {
        try {
          if (result.isConfirmed) {
            callback();
            Swal.fire(
              t('general.good', { ns: 'validations' }) || '',
              t('general.approve', { ns: 'validations' }) || '',
              'success',
            );
          } else {
            return null;
          }
        } catch (error) {
          console.error('Error al eliminar la factura', error);
          Swal.fire({
            title: t('general.error', { ns: 'common' }) || '',
            text: t('general.deleteFailed', { ns: 'common' }) || '',
            icon: 'error',
          });
        }
      });
    }
  };

  const activeCCFAlert = (callback: () => {}) => {
    activeSwalModal(t('general.sure', { ns: 'validations' }), t('general.ccfAlert', { ns: 'validations' }), callback);
  };

  const onSubmit = async (data: CFFCaptureData) => {
    const postGenerateBill = async (id: number) => {
      return await axiosEstimates.post(`/api/create-bill/${id}?billType=${2}`, data);
    };
    try {
      await activeCCFAlert(async () => {
        if (budgetId) {
          try {
            const response = await postGenerateBill(parseInt(budgetId));
            if (response.data.alertFolio) {
              Swal.fire({
                title: t('general.error', { ns: 'common' }) || '',
                text: t('general.folioAlert', { ns: 'common' }) || '',
                icon: 'warning',
              });
            }
            if (response.status === 200) window.history.back();
            else {
              Swal.fire({
                title: t('general.error', { ns: 'common' }) || '',
                text: t('general.folioAlert', { ns: 'common' }) || '',
                icon: 'error',
              });
            }
          } catch (error) {
            Swal.fire({
              title: t('general.error', { ns: 'common' }) || '',
              text: t('general.folioAlert', { ns: 'common' }) || '',
              icon: 'error',
            });
          }
        }
      });
    } catch (error) {
      // No es necesario manejar un error aquí, ya que la función activeFFAlert se encarga de eso
    }
  };
  const cancel = () => {
    // eslint-disable-next-line no-console
    window.history.back();
  };

  return { t, control, navigate, onSubmit, cancel, handleDataInput, getValues, setValue, total };
}
